import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectors as loyaltyOffersSelectors } from '../loyalty-offers/loyalty-offers.slice';
import { useLoyaltyOffers } from '../loyalty-offers/loyalty-offers.hooks';

export const useLoyaltyAppcontent = () => {
  const {
    fetchLoyaltyOffers,
    loyaltyOffersRetrievedPages,
    loyaltyOffersHasMore,
  } = useLoyaltyOffers();

  const fetchLoyaltyAppcontent = useCallback(
    ({ page, count } = {}) => {
      const promises = [];
      if (loyaltyOffersHasMore)
        promises.push(
          fetchLoyaltyOffers({
            page:
              page ||
              (loyaltyOffersRetrievedPages
                ? loyaltyOffersRetrievedPages + 1
                : 1),
            count,
            loyalty: true,
          }),
        );

      return Promise.all(promises);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fetchLoyaltyOffers, loyaltyOffersHasMore, loyaltyOffersRetrievedPages],
  );

  const loyaltyContent = useSelector(
    loyaltyOffersSelectors.selectSortedLoyaltyOffers,
  );
  const totalLoyalty = useSelector(
    loyaltyOffersSelectors.selectTotalLoyaltyOffers,
  );
  const hasMore = useSelector(loyaltyOffersSelectors.selectHasMore);
  const loading = useSelector(loyaltyOffersSelectors.selectLoading);

  return {
    fetchAppcontent: fetchLoyaltyAppcontent,
    loyaltyContent,
    totalLoyalty,
    hasMore,
    loading,
  };
};
